import {useQuery} from "@tanstack/react-query"
import {generalSettingsService} from "services"
import {YesNo} from "types/common"
import {GeneralSettingField} from "types/settings/general-setting"

export const HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY = [
    "general-settings",
    GeneralSettingField.AdmHideFunnelInStudentDetails
] as const

export function useHideFunnelInStudentDetails() {
    const {data, isFetched, isFetching} = useQuery(
        HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY,
        () => generalSettingsService.getSettings([GeneralSettingField.AdmHideFunnelInStudentDetails]),
        {initialData: []}
    )

    const hideFunnelInStudentDetails =
        data?.find((item) => item.field === GeneralSettingField.AdmHideFunnelInStudentDetails)?.value === YesNo.Yes

    return {
        hideFunnelInStudentDetails: isFetched ? hideFunnelInStudentDetails : false,
        isLoadingHideFunnelSetting: isFetching
    }
}
